import React from 'react'

import Icon from '../icons/Icon'

export interface ButtonLinkProps {
  text: string;
  onClick: () => void;
  arrowDirection?: 'left' | 'right';
}

const ButtonLink = ({text, onClick, arrowDirection}: ButtonLinkProps) => {
  return (
    <button
      onClick={onClick}
      className="flex relative items-center gap-1 font-semibold duration-300 font-titillium text-kwota-neutral-700 after:content-[''] after:absolute hover:after:w-full after:h-0.5 after:bg-kwota-neutral-700 after:-bottom-[2px] after:w-0 after:transition-all after:duration-200 after:ease-out"
    >
      {arrowDirection === 'left' &&
        <Icon size="sm" className="" icon="arrow-left" />
      }
      {text}
      {arrowDirection === 'right' && <Icon size="sm" icon="arrow-right" />}
    </button>
  )
}

export default ButtonLink
